var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('vk-card',[_c('h1',[_vm._v("Informazioni su")]),_c('a',{attrs:{"href":"http://ensys.it/"}},[_vm._v("Ensys S.R.L.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }